/* global Waypoint */
import { TweenLite, Power3 } from 'gsap'
import Barba from 'barba.js'
import TimelineMax from 'gsap/TimelineMax'

let bodyClass

export default {
  init (routes, siteMenu) {
    Barba.Pjax.preventCheck = function (evt, element) {
      if (!window.history.pushState) {
        return false
      }

      var href = this.getHref(element)

      // User
      if (!element || !href) {
        return false
      }

      // Middle click, cmd click, and ctrl click
      if (evt.which > 1 || evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) {
        return false
      }

      // Ignore target with _blank target
      if (element.target && element.target === '_blank') {
        return false
      }

      // Check if it's the same domain
      if (window.location.protocol !== element.protocol || window.location.hostname !== element.hostname) {
        return false
      }

      // Check if the port is the same
      if (Barba.Utils.getPort() !== Barba.Utils.getPort(element.port)) {
        return false
      }

      // Ignore case where there is download attribute
      if (element.getAttribute && typeof element.getAttribute('download') === 'string') {
        return false
      }

      // In case you're trying to load the same page
      if (Barba.Utils.cleanLink(href) === Barba.Utils.cleanLink(location.href)) {
        return false
      }

      if (element.classList.contains(this.ignoreClassLink)) {
        return false
      }

      return true
    }

    const transitionTimeline = new TimelineMax()
    var FadeTransition = Barba.BaseTransition.extend({
      start: function () {
        /**
         * This function is automatically called as soon the Transition starts
         * this.newContainerLoading is a Promise for the loading of the new container
         * (Barba.js also comes with an handy Promise polyfill!)
         */
        // As soon the loading is finished and the old page is faded out, let's fade the new page
        Promise
          .all([this.newContainerLoading, this.transitionAnimation()])
          .then(this.imagesLoaded.bind(this))
          .then(this.finish.bind(this))
      },

      transitionAnimation: function () {
        const promise = new Promise((resolve, reject) => {
          // transitionTimeline.timeScale(0.1)
          transitionTimeline
            .clear()
            .set(
              $('.transition-overlay'),
              { autoAlpha: 1, transformOrigin: 'left bottom' }
            )
            .staggerFromTo(
              $('.transition-overlay'),
              1,
              { scaleY: 0 },
              { scaleY: 1, ease: Power3.easeInOut },
              0.1
            )
            .call(() => {
              console.log('transition callback')
              if (window.location.href.includes('/products/')) {
                window.location.replace(window.location.origin + window.location.pathname + '?rl=1')
              } else {
                TweenLite.set($(window), { scrollTo: 0 })
                resolve()
              }
            })
        })
        return promise
      },

      imagesLoaded: function () {
        const promise = new Promise((resolve, reject) => {
          window.imagesLoaded(this.newContainer, { background: true }, () => {
            resolve()
          })
        })
        return promise
      },

      finish: function () {
        this.done()
      },
    })

    /**
     * Next step, you have to tell Barba to use the new Transition
     */
    Barba.Pjax.getTransition = () => { return FadeTransition }

    Barba.Dispatcher.on('linkClicked', function (link, event) { siteMenu.toggle(false) })

    Barba.Dispatcher.on('newPageReady', function (currentStatus, prevStatus, container, rawHTML) {
      // Save body classes of new page
      bodyClass = $(rawHTML).filter('#barba-wrapper').children('main').data('bodyClass')

      // Update the active class in the site menu
      var $currentMenuItems = $(rawHTML).filter('.site-menu, .site-footer').find('.current-menu-item')
      $('.menu-item').removeClass('current-menu-item')
      $currentMenuItems.each(function (i, el) {
        const href = $(el).find('a').attr('href')
        $('.site-menu, .site-footer')
          .find(`.menu-item a[href="${href}"]`)
          .closest('li')
          .addClass('current-menu-item')
      })
    })

    Barba.Dispatcher.on('transitionCompleted', function (currentStatus, prevStatus, container, rawHTML) {
      // Call the destroy function for current routes
      routes.destroyEvents()

      // Switch body classes in order for DOM based routing to function properly
      $('body').attr('class', bodyClass)

      // This is required for the footer
      Waypoint.refreshAll()

      // Call init and finalize functions for new routes
      routes.loadEvents()
      TweenLite.set($('.transition-overlay'), { autoAlpha: 0 })
    })

    let firstLoad = true
    Barba.Dispatcher.on('initStateChange', function () {
      if (firstLoad) {
        firstLoad = false
        return
      }

      if (typeof window.ga === 'function') {
        window.ga('send', 'pageview', location.pathname)
      }
    })

    Barba.Pjax.start()
  },
}



// WEBPACK FOOTER //
// ./scripts/util/barba.js